import AxiosService from "./axiosServices";
const axiosService = new AxiosService();

export default class Shared {
  getFoldersAndFiles = (id) => {
    const params = {
      folder_id: id,
    };
    if (id) {
      return axiosService.Get(`api/explore-box-dir/`, {
        params: params,
      });
    } else {
      return axiosService.Get(`api/explore-box-dir/`);
    }
  };

  getFileUrl = (id) => {
    const params = {
      file_id: id,
    };
    return axiosService.Get(`api/preview-box-file/`, {
      params: params,
    });
  };

  getPendingBatchesList = () => {
    return axiosService.Get(`api/list-pending-batches/`);
  };
}
